import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import { GDialog, plugin as dialogPlugin } from 'gitart-vue-dialog'
import 'gitart-vue-dialog/dist/style.css'

const app = createApp(App)
app
  .use(router)
  .use(store)
  .use(dialogPlugin)
  .component('GDialog', GDialog)
  .mount('#app')
